import {Cart} from '../../../shared-gen/Model/Orders/Cart';

export class CartFun {

	static createNew(): Cart {
		return {
			Items: [],
			TotalPriceWithDeposit: 0,
			AccumulatedProducts: []
		}
	}

}
